export default {"src":"/_next/static/image/public/images/ic_calendar_vertical_menu.5222152615cf4b499d21fa444bbe3564.svg","height":20,"width":20};